module.exports = __webpack_public_path__ + "static/thief-fb6d637a97f4ad542c9574776a7ef3d6.jpg";